// Тексты окна входа по звонку (решение 23.10: тест на бабушку, без лишних шагов).
// Окно одно и для входа, и для регистрации: новый номер сам становится аккаунтом.

export function phoneStepText(kind) {
  if (kind === "save") {
    return {
      title: "Сохраним расчёт",
      lede: "Нужен только номер телефона. Пароль и банковская карта не нужны.",
    };
  }
  if (kind === "trial") {
    return {
      title: "7 дней бесплатно",
      lede: "Нужен только номер телефона. Пароль и банковская карта не нужны.",
    };
  }
  return {
    title: "Вход в Упрости",
    lede: "По номеру телефона, пароль не нужен. Если вы у нас впервые, аккаунт появится сам.",
  };
}

// «+7 800 555 35 35» из libphonenumber → «+7 800 555-35-35», как номера пишут в России.
export function groupPhone(international) {
  const parts = String(international || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length < 4) return parts.join(" ");
  return `${parts[0]} ${parts[1]} ${parts.slice(2).join("-")}`;
}

function plural(count, one, few, many) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

// Сколько живёт номер для звонка, от начала попытки: «Позвоните в течение 5 минут.»
export function callWindowText(expiresAt, startedAt) {
  const ms = Number(new Date(expiresAt)) - Number(startedAt);
  if (!Number.isFinite(ms) || ms <= 0) return "";
  const minutes = Math.max(1, Math.round(ms / 60000));
  return `Позвоните в течение ${minutes} ${plural(minutes, "минуты", "минут", "минут")}.`;
}
